interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, desc, align = "left" }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`max-w-3xl ${isCenter ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest uppercase text-primary-600">
          <i className="ri-bookmark-3-line"></i>
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc && (
        <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>
      )}
    </div>
  );
}